// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__-hIaU","unreadBadge":"styles_unreadBadge__Y5kw1","modalContent":"styles_modalContent__24-Jq","modal":"styles_modal__2X6nl"};